import { render, staticRenderFns } from "./poster-type-selector.vue?vue&type=template&id=62af1675&"
import script from "./poster-type-selector.vue?vue&type=script&lang=js&"
export * from "./poster-type-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports